<template>
  <div v-if="!selecionouSegmento">
    <div class="segmento-container" v-for="registro in segmento.dados">
      <RadioButton
        v-if="segmento.dados.length > 1"
        :seleciona="seleciona"
        :classe="classe"
        :imposto="registro"
        :loading="loading"
      />
      <Registro :paddingSemCheckBox="segmento.dados.length <= 1" v-if="registro.id_imposto != 100">
        <Descricao :titulo="'Segmento'" :descricao="registro.segmento" />
        <div v-if="registro.segmento" class="separador" />
        <div>
          <Descricao
            v-if="registro.regra_responsabilidade && registro.regra_responsabilidade.length > 15"
            titulo="Atribuição de Responsabilidade"
            :descricao="registro.regra_responsabilidade"
          />
          <Cabecalho
            v-else
            paddingBottom
            titulo="Atribuição de Responsabilidade"
            :aliquota="registro.regra_responsabilidade"
          />
        </div>

        <div v-if="registro.regra_responsabilidade" class="separador" />
        <Ncm :ncm="registro.ncm_uf" />
        <div v-if="registro.ncm_uf" class="separador" />
        <Descricao
          v-if="!!registro.descricao_uf"
          :titulo="'Descrição'"
          :descricao="registro.descricao_uf"
        />
        <div v-if="registro.descricao_uf" class="separador" />
        <Cabecalho
          v-if="registro.valor_label"
          paddingBottom
          titulo="Carga Líquida"
          tipo="icone"
          :classe="classe"
          :aliquota="registro.valor_label"
        />
        <div v-if="registro.valor_label && registro.base_legal_incidencia" class="separador" />
        <BaseLegal :base_legal="registro.base_legal_incidencia" />
      </Registro>

      <Registro :paddingSemCheckBox="segmento.dados.length <= 1" v-else>
        <Cabecalho paddingBottom titulo="Inaplicabilidade da Carga Líquida" />
        <Inaplicabilidade :texto="registro.texto_inaplicabilidade" />
      </Registro>
    </div>
  </div>

  <div :key="getRenderKey" v-else>
    <div class="segmento-container">
      <EditButton
        v-if="segmento.dados.length > 1"
        :classe="classe"
        :edita="edita"
        :loading="loading"
      />
      <Registro
        :paddingSemCheckBox="segmento.dados.length <= 1"
        v-if="segmentoSelecionado.id_imposto != 100"
      >
        <Descricao :titulo="'Segmento'" :descricao="segmentoSelecionado.segmento" />
        <div v-if="segmentoSelecionado.segmento" class="separador" />
        <!-- RESPONSABILIDADE TEM TAMANHOS E EXIBIÇÕES VARIADAS, POR ISSO FOI CRIADO UM V-IF PARA ESCOLHER COMO EXIBIR -->
        <div>
          <Descricao
            v-if="
              segmentoSelecionado.regra_responsabilidade &&
                segmentoSelecionado.regra_responsabilidade.length > 15
            "
            titulo="Atribuição de Responsabilidade"
            :descricao="segmentoSelecionado.regra_responsabilidade"
          />
          <Cabecalho
            v-else
            paddingBottom
            titulo="Atribuição de Responsabilidade"
            :aliquota="segmentoSelecionado.regra_responsabilidade"
          />
        </div>
        <!-- FIM -->
        <div v-if="segmentoSelecionado.regra_responsabilidade" class="separador" />
        <Ncm :ncm="segmentoSelecionado.ncm_uf" />
        <div v-if="segmentoSelecionado.ncm_uf" class="separador" />
        <Descricao
          v-if="!!segmentoSelecionado.descricao_uf"
          :titulo="'Descrição'"
          :descricao="segmentoSelecionado.descricao_uf"
        />
        <div v-if="segmentoSelecionado.descricao_uf" class="separador" />
        <Cabecalho
          v-if="segmentoSelecionado.valor_label"
          paddingBottom
          titulo="Carga Líquida"
          tipo="icone"
          :classe="classe"
          :aliquota="segmentoSelecionado.valor_label"
        />
        <div
          v-if="segmentoSelecionado.valor_label && segmentoSelecionado.base_legal_incidencia"
          class="separador"
        />
        <BaseLegal :base_legal="segmentoSelecionado.base_legal_incidencia" />
      </Registro>

      <Registro :paddingSemCheckBox="segmento.dados.length <= 1" v-else>
        <Cabecalho paddingBottom titulo="Inaplicabilidade da Carga Líquida" />
        <Inaplicabilidade :texto="segmentoSelecionado.texto_inaplicabilidade" />
      </Registro>
    </div>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Inaplicabilidade from "@/components/Inaplicabilidade/Inaplicabilidade.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro";

import { mapGetters } from "vuex";

export default {
  name: "RegistrosSegmentoCargaLiquida",

  props: {
    classe: String,
    loading: Boolean,
    segmento: Object | Array,
    seleciona: Function,
    segmentoSelecionado: Object,
    selecionouSegmento: Boolean,
    edita: Function
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    Inaplicabilidade,
    Ncm,
    Notificacao,
    RadioButton,
    Registro
  },

  data() {
    return {};
  },
  created() {
    //se tiver apenas um resultado, seleciona o mesmo.
    if (this.segmento.dados.length == 1) {
      this.seleciona(this.segmento.dados[0]);
    }
  },
  updated() {
    //se tiver apenas um resultado, seleciona o mesmo.
    if (this.segmento.dados.length == 1) {
      this.seleciona(this.segmento.dados[0]);
    }
  },
  mounted() {},

  computed: {
    ...mapGetters("reRender", ["getRenderKey"])
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.segmento-container {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}
</style>
